import Router from 'vue-router';
import Vue from 'vue';

import EditCompany from '@/components/organisation/EditCompany';
import EditPerson from '@/components/organisation/EditPerson';
import EditProject from '@/components/project/EditProject';
import EditInspectionTemplates from '@/components/project/EditInspectionTemplates';
import EditInspectionTemplate from '@/components/project/EditInspectionTemplate';
import EditInspectionTemplateSection from '@/components/project/EditInspectionTemplateSection';
import EditTodoTemplates from '@/components/project/EditTodoTemplates';
import LoginForm from '@/components/login/LoginForm';
import OrganisationOverview from '@/components/organisation/OrganisationOverview';
import PersonList from '@/components/organisation/PersonList';
import UpdatePhones from '@/components/organisation/UpdatePhones';
import ProjectActionPlan from '@/components/projectoverview/ProjectActionPlan';
import ProjectList from '@/components/projectlist/ProjectList';
import ProjectLogUpdate from '@/components/projectoverview/ProjectLogUpdate';
import ProjectObject from '@/components/projectoverview/ProjectObject';
import ProjectOverview from '@/components/projectoverview/ProjectOverview';
import ProjectPlan from '@/components/projectplan/ProjectPlan';
import ProjectPlanEdit from '@/components/projectplan/ProjectPlanEdit';
import ProjectPlanPrint from '@/components/projectplanprint/ProjectPlanPrint';
import ViewProjectContacts from '@/components/project/ViewProjectContacts';
import Diary from '@/components/diary/Diary';
import DiaryListDates from '@/components/diary/DiaryListDates';
import DiaryEdit from '@/components/diary/DiaryEdit';
import DiaryEditEntries from '@/components/diary/DiaryEditEntries';
import DiaryConfirm from '@/components/diary/DiaryConfirm';
import GoodJob from '@/components/good-job/GoodJob';
import VModal from 'vue-js-modal';

Vue.use(Router);

// Add support for modals
Vue.use(VModal);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginForm,
    },
    {
      path: '/projectlist',
      name: 'ProjectList',
      component: ProjectList,
    },
    {
      path: '/project/new',
      name: 'AddProject',
      component: EditProject,
    },
    {
      path: '/projectplan/:_id',
      name: 'ProjectPlan',
      component: ProjectPlan,
      children: [
        {
          path: 'edit',
          name: 'ProjectPlanEdit',
          component: ProjectPlanEdit,
        },
        {
          path: 'part/:partId',
          name: 'ProjectPlanPart',
          component: ProjectPlanEdit,
        },
        {
          path: 'stage/:stageId',
          name: 'ProjectPlanStage',
          component: ProjectPlanEdit,
        },
        {
          path: 'diary/:date',
          name: 'ProjectPlanDiaryEntry',
          component: ProjectPlanEdit,
        },
        {
          path: 'settings',
          name: 'ProjectPlanSettings',
          component: ProjectPlanEdit,
        },
        {
          path: 'print',
          name: 'ProjectPlanPrint',
          component: ProjectPlanPrint,
        },
      ],
    },
    {
      path: '/object/:_id',
      name: 'ProjectObject',
      component: ProjectObject,
      meta: {
        section: 'ProjectSettings',
      },
    },
    {
      path: '/projectoverview/:_id',
      component: ProjectOverview,
      children: [
        {
          path: 'overview',
          name: 'ProjectOverview',
          component: ProjectActionPlan,
        },
        {
          path: 'actions',
          name: 'ProjectActionPlan',
          component: ProjectActionPlan,
        },
        {
          path: 'contacts',
          name: 'ViewProjectContacts',
          component: ViewProjectContacts,
        },
        {
          path: 'log',
          name: 'ProjectLog',
          component: ProjectLogUpdate,
          meta: {
            section: 'ProjectSettings',
          },
        },
        {
          path: 'edit',
          name: 'EditProject',
          component: EditProject,
          meta: {
            section: 'ProjectSettings',
          },
        },
        {
          path: 'todotemplates',
          name: 'EditTodoTemplates',
          component: EditTodoTemplates,
          meta: {
            section: 'ProjectSettings',
          },
        },
        {
          path: 'inspectiontemplates',
          name: 'EditInspectionTemplates',
          component: EditInspectionTemplates,
          meta: {
            section: 'ProjectSettings',
          },
        },
        {
          path: 'inspectiontemplate/:inspectionTemplateId',
          name: 'EditInspectionTemplate',
          props: (route) => ({ projectId: route.params._id, inspectionTemplateId: route.params.inspectionTemplateId }),
          component: EditInspectionTemplate,
          meta: {
            section: 'ProjectSettings',
          },
        },
        {
          path: 'inspectiontemplate/:inspectionTemplateId/:inspectionSectionId',
          name: 'EditInspectionSection',
          props: (route) => ({
            projectId: route.params._id,
            inspectionTemplateId: route.params.inspectionTemplateId,
            inspectionSectionId: route.params.inspectionSectionId,
          }),
          component: EditInspectionTemplateSection,
          meta: {
            section: 'ProjectSettings',
          },
        },
      ],
    },
    {
      path: '/organisation/',
      component: OrganisationOverview,
      children: [
        {
          path: '/',
          name: 'OrganisationOverview',
          component: PersonList,
        },
        {
          path: 'company/new',
          name: 'AddCompany',
          component: EditCompany,
        },
        {
          path: 'company/:_id',
          name: 'EditCompany',
          component: EditCompany,
        },
        /**
         * @todo This route isn't used anywhere right now. If there will be no use for it then EditPerson component
         * should be cleaned up of unnecessary code.
         */
        // {
        //   path: 'person/new',
        //   name: 'AddPerson',
        //   component: EditPerson
        // },
        {
          path: 'person/:_id',
          name: 'EditPerson',
          component: EditPerson,
        },
        {
          path: 'update-phones/:entityType',
          name: 'UpdatePhones',
          component: UpdatePhones,
        },
      ],
    },
    {
      path: '/diary/',
      component: Diary,
      children: [
        {
          path: '/diary/:_id/',
          name: 'Diary',
          component: DiaryListDates,
        },
        {
          path: '/diary/:_id/:date',
          name: 'DiaryEdit',
          component: DiaryEdit,
        },
        {
          path: '/diary/:_id/:date',
          name: 'DiaryEditEntries',
          component: DiaryEditEntries,
        },
        {
          path: '/diary/confirm/:_id/:date',
          name: 'DiaryConfirm',
          component: DiaryConfirm,
        },
      ],
    },
    {
      path: '/good-job',
      name: 'GoodJob',
      component: GoodJob,
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js